/**
 * Utilitários de data (dd/MM/yyyy ↔ YYYY-MM-DD) e atalhos de período — relatórios.
 */

export function toYMD(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export const PERIOD_PRESETS = [
  { id: '30', label: '\u00daltimos 30 dias' },
  { id: '60', label: '\u00daltimos 60 dias' },
  { id: '90', label: '\u00daltimos 90 dias' },
  { id: 'month', label: 'M\u00eas atual' },
];

export function maskBrDateInput(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function ymdToBr(ymd) {
  if (!ymd) return '';
  const parts = String(ymd).split('-');
  if (parts.length !== 3) return '';
  const [y, m, d] = parts;
  return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
}

export function parseBrDateToYmd(str) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(str ?? '').trim());
  if (!m) return null;
  const day = parseInt(m[1], 10);
  const month = parseInt(m[2], 10) - 1;
  const year = parseInt(m[3], 10);
  const date = new Date(year, month, day);
  if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) return null;
  return toYMD(date);
}

function addDaysToYmd(ymd, deltaDays) {
  const [y, mo, d] = ymd.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, mo - 1, d);
  date.setDate(date.getDate() + deltaDays);
  return toYMD(date);
}

export function getPresetRange(presetId, todayYmd) {
  const end = todayYmd;
  if (presetId === '30') return { startDate: addDaysToYmd(end, -29), endDate: end };
  if (presetId === '60') return { startDate: addDaysToYmd(end, -59), endDate: end };
  if (presetId === '90') return { startDate: addDaysToYmd(end, -89), endDate: end };
  if (presetId === 'month') {
    const [y, mo] = end.split('-');
    return { startDate: `${y}-${mo}-01`, endDate: end };
  }
  return null;
}
